import { Meilisearch } from 'meilisearch';

import type { Instance } from '../types.ts';

interface Config {
  MEILISEARCH_URL: string;
  MEILISEARCH_SEARCH_API_KEY: string;
  MEILISEARCH_INDEX: string;
}

let client: Meilisearch | null = null;
let indexName: string | null = null;

async function initClient(): Promise<void> {
  if (client) return;

  const res = await fetch('/config.json');
  if (!res.ok) {
    throw new Error('Failed to load search configuration');
  }

  const config = (await res.json()) as Config;

  client = new Meilisearch({
    host: config.MEILISEARCH_URL,
    apiKey: config.MEILISEARCH_SEARCH_API_KEY,
  });

  indexName = config.MEILISEARCH_INDEX;
}

export async function searchInstances(query: string): Promise<Instance[]> {
  await initClient();

  if (!client || !indexName) {
    throw new Error('Search client not initialized');
  }

  const response = await client.index(indexName).search<Instance>(query, {
    limit: query.trim() ? 20 : 4,
  });

  return response.hits;
}

export async function getInstanceCount(): Promise<number> {
  await initClient();

  if (!client || !indexName) {
    throw new Error('Search client not initialized');
  }

  const response = await client.index(indexName).search<Instance>('', {
    limit: 0,
  });

  return response.estimatedTotalHits ?? 0;
}
